import React, { Component } from 'react';
import firebase from 'firebase';
import {
  Button,
  Modal,
  FormControl,
  Navbar,
  Form,
  InputGroup,
  FormGroup,
  ControlLabel,
  Nav,
  MenuItem,
  PageHeader,
  Grid,
} from 'react-bootstrap';
import { notify } from 'react-notify-toast';

type IState = {
  email: string,
  password: string,
  show: boolean,
};

class Login extends Component {
  constructor(props: any) {
    super(props);

    this.state = {
      email: '',
      password: '',
      show: false,
    };
  }

  state: IState;

  handleEmailChanged(e) {
    const email = e.target.value;

    this.setState({
      email,
    });
  }

  handlePasswordChanged(e) {
    const password = e.target.value;

    this.setState({
      password,
    });
  }

  handleSubmit(e) {
    e.preventDefault();

    const { email, password } = this.state;

    this.setState({
      show: false,
    });

    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(ok => {
        firebase
          .database()
          .ref(`users`)
          .orderByChild('uid')
          .equalTo(ok.uid)
          .on('value', snapshots => {
            let admin = false;

            const users = snapshots.val();
            Object.keys(users).forEach(key => {
              const user = users[key];
              if (user.lecturer) {
                const room = Object.keys(user.lecturer).find(
                  room => user.lecturer[room] === true,
                );
                if (room) {
                  localStorage.setItem('room', room);
                  admin = true;
                  this.props.onSuccess();
                }
              }
            });

            if (admin) {
              notify.show(`Welcome ${email}!`, 'success', 5000);
            } else {
              notify.show(`You don't have permissons!`, 'error', 5000);
              firebase.auth().signOut();
            }
          });
      })
      .catch(error => {
        notify.show(error.message, 'error', 5000);

        this.setState({
          show: true,
        });
      });
  }

  handleLogin() {
    this.setState({
      show: true,
    });
  }

  handleOnClose() {
    this.setState({
      show: false,
    });
  }

  render() {
    const { email, password, show } = this.state;

    return (
      <div>
        <Navbar collapseOnSelect staticTop>
          <Navbar.Header>
            <Navbar.Brand>
              <a href='/'>
                Angličtina{' '}
                <strong className='primary' style={{ color: '#0eb2ff' }}>
                  #TODAY
                </strong>
              </a>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav pullRight>
              <MenuItem onClick={this.handleLogin.bind(this)}>
                Lecturer Sign in
              </MenuItem>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <Modal
          show={show}
          onHide={this.handleOnClose.bind(this)}
          backdrop={'static'}
        >
          <Form onSubmit={this.handleSubmit.bind(this)}>
            <Modal.Header closeButton>
              <Modal.Title>Sign In</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <FormGroup controlId='email'>
                <ControlLabel>Your email</ControlLabel>
                <FormControl
                  id='email'
                  type='text'
                  onChange={this.handleEmailChanged.bind(this)}
                  value={email}
                />
              </FormGroup>
              <FormGroup controlId='password'>
                <ControlLabel>Your password</ControlLabel>
                <FormControl
                  id='password'
                  type='password'
                  onChange={this.handlePasswordChanged.bind(this)}
                  value={password}
                />
              </FormGroup>
            </Modal.Body>
            <Modal.Footer>
              <Button
                type='submit'
                bsStyle='primary'
                onClick={this.handleSubmit.bind(this)}
              >
                Sign In
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        <Grid>
          <div style={{ textAlign: 'center' }}>
            <br />
            <br />
            <img src='/logo.png' style={{ maxWidth: '80%' }} alt='Logo' />
            <PageHeader>
              Dear students, start{' '}
              <span style={{ color: '#0eb2ff' }}>#TODAY</span>
            </PageHeader>
            <a href='https://itunes.apple.com/us/app/angli%C4%8Dtina-today/id1436713454?l=cs&ls=1&mt=8'>
              <img
                alt='Get it on App Store'
                src='/app-store.svg'
                style={{ height: '80px', margin: '10px' }}
              />
            </a>
            <a href='https://play.google.com/store/apps/details?id=cz.uhk.fim.anglictinatoday&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
              <img
                alt='Get it on Google Play'
                src='/google-play.png'
                style={{ height: '80px', margin: '10px' }}
              />
            </a>
          </div>
        </Grid>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/pages/Login/index.js